// Actions
export const ADD_ITEM = 'companyExperience/entities/companyAccounts/ADD_ITEM'

// Action Creators

export const addItem = (id, item) => ({
  type: ADD_ITEM,
  meta: { id },
  payload: item,
})

// Reducers
const defaultEntity = {}

const entity = (state = defaultEntity, { type, payload }) => {
  switch (type) {
    case ADD_ITEM:
      return { ...state, ...payload }

    default:
      return state
  }
}

const defaultMap = {}

const map = (state = defaultMap, { type, meta, payload }) => {
  switch (type) {
    case ADD_ITEM:
      return {
        ...state,
        [meta.id]: entity(state[meta.id], { type, payload }),
      }

    default:
      return state
  }
}

export default map

export const getCompanyAccountsMap = state => state.entities.companyAccounts || defaultMap
export const getCompanyAccountsItem = (state, id) => state.entities.companyAccounts[id] || defaultEntity
